import { computed } from 'vue';
import { useWooStore } from '~/stores/woo';

export const useAddToCartState = (props: { isButtonActive: boolean; isStatusBundle: boolean }) => {
    const wooStore = useWooStore();
    const isOutOfStock = computed(() => wooStore.singleProduct.status === 'outofstock');
    const isDisabled = computed(() =>
        isOutOfStock.value || !props.isButtonActive || !props.isStatusBundle
    );

    return { isOutOfStock, isDisabled };
};
